/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Promo } from './Promo'
import { PromoFromJSON, PromoFromJSONTyped, PromoToJSON } from './Promo'

/**
 *
 * @export
 * @interface Promocode
 */
export interface Promocode {
  /**
   * Уникальный идентификатор промокода
   * @type {number}
   * @memberof Promocode
   */
  id?: number
  /**
   * Код промокода
   * @type {string}
   * @memberof Promocode
   */
  code?: string
  /**
   * количество использований
   * @type {number}
   * @memberof Promocode
   */
  number?: number
  /**
   * Статус активности промокода
   * @type {boolean}
   * @memberof Promocode
   */
  active?: boolean
  /**
   *
   * @type {Promo}
   * @memberof Promocode
   */
  promo?: Promo
  /**
   * Дата создания записи
   * @type {Date}
   * @memberof Promocode
   */
  createdAt?: Date
  /**
   * Дата последнего обновления записи
   * @type {Date}
   * @memberof Promocode
   */
  updatedAt?: Date
  /**
   * Дата начала действия промокода
   * @type {Date}
   * @memberof Promocode
   */
  startAt?: Date
  /**
   * Дата окончания действия промокода
   * @type {Date}
   * @memberof Promocode
   */
  expiredAt?: Date
}

/**
 * Check if a given object implements the Promocode interface.
 */
export function instanceOfPromocode(value: object): value is Promocode {
  return true
}

export function PromocodeFromJSON(json: any): Promocode {
  return PromocodeFromJSONTyped(json, false)
}

export function PromocodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Promocode {
  if (json == null) {
    return json
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    code: json['code'] == null ? undefined : json['code'],
    number: json['number'] == null ? undefined : json['number'],
    active: json['active'] == null ? undefined : json['active'],
    promo: json['promo'] == null ? undefined : PromoFromJSON(json['promo']),
    createdAt:
      json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt:
      json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    startAt: json['startAt'] == null ? undefined : new Date(json['startAt']),
    expiredAt:
      json['expiredAt'] == null ? undefined : new Date(json['expiredAt']),
  }
}

export function PromocodeToJSON(value?: Promocode | null): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    code: value['code'],
    number: value['number'],
    active: value['active'],
    promo: PromoToJSON(value['promo']),
    createdAt:
      value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt:
      value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    startAt:
      value['startAt'] == null ? undefined : value['startAt'].toISOString(),
    expiredAt:
      value['expiredAt'] == null ? undefined : value['expiredAt'].toISOString(),
  }
}
